import { Component, ElementRef, ViewChild, Inject, OnInit, Renderer2 } from '@angular/core';
import {
  IReportEmbedConfiguration,
  models,
  service,
} from 'powerbi-client';

import { PowerBIReportEmbedComponent } from 'powerbi-client-angular';
import { HttpClient } from '@angular/common/http';

import { PowerBIService } from 'app/services/powerbi.service';
import { ActivatedRoute, Router } from '@angular/router';
import { relative } from 'path';
import { AuthWebService } from 'app/services/authweb.service';


@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
  @ViewChild(PowerBIReportEmbedComponent)
  reportObj!: PowerBIReportEmbedComponent;
  phasedEmbeddingFlag = false;
  isEmbedded = false;
  displayMessage = 'Please wait while your report is being fetched.';
  reportClass = 'is-embedded report-container';
  carrierCode;
  isSanralRole: boolean = false;
  reportIds: Report[] = [];
  selectedReportId: any | undefined;
  reportConfig: IReportEmbedConfiguration = {
    type: 'report',
    tokenType: models.TokenType.Embed,
    permissions: models.Permissions.Read,
  };

  eventHandlersMap = new Map<string, (event?: service.ICustomEvent<any>) => void>([
    ['loaded', () => {
      this.isEmbedded = true;
      console.log('Report has loaded.');
    }],
    ['rendered', () => console.log('Report has rendered')],
    ['error', (event?: service.ICustomEvent<any>) => {
      if (event) {
        console.error(event.detail);
      }
    }],
    ['visualClicked', () => console.log('Visual clicked')],
    ['pageChanged', (event) => console.log(event)]
  ]);

  constructor(
    public http: HttpClient,private _activatedRoute: ActivatedRoute,private router: Router,
    public powerBIService: PowerBIService,private authWebService: AuthWebService, private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.loadReportIds();
    const reportContainer = this.renderer.selectRootElement('.is-embedded report-container');
    this.renderer.setStyle(reportContainer, 'height', '100vh');
    if (this.authWebService.userData.Roles[0].Name=='Sanral Staff') {
      this.isSanralRole = true;
    }

  }
    // this.embedReport();
  
  onReportSelectionChange(reportId: string): void {
    this.selectedReportId = reportId;
    console.log('Selected Report ID:', this.selectedReportId);
    this.embedReport(); // Call the method to embed the selected report
  }
  
  onBack() {
    this.router.navigateByUrl("carrier/accounts");
  }
  
  loadReportIds(): void {
    this.powerBIService.getSanralReportId()
      .subscribe(
        (data: Report[]) => {
          this.reportIds = data;
          console.log("data stuff",data)
          this.selectedReportId = data.length > 0 ? data[0] : undefined;
          this.onReportSelectionChange(this.selectedReportId);
        },
        (error) => {
          console.error('Error fetching report IDs:', error);
        }
      );
  }
  
  

  async embedReport(): Promise<void> {
    try {
      const result = await this.powerBIService.getSanralReport( this.selectedReportId).toPromise();
      const embedParams = result as EmbedParams;
  console.log("embed params",embedParams)
      this.reportConfig = {
        ...this.reportConfig,
        id: embedParams.EmbedReport[0].ReportId,
        embedUrl: embedParams.EmbedReport[0].EmbedUrl,
        accessToken: embedParams.EmbedToken.Token,
        settings: {
          filterPaneEnabled: true,
          navContentPaneEnabled: true,
          layoutType: models.LayoutType.Custom ,
          customLayout: {
            displayOption: models.DisplayOption.FitToPage
          }
        }
      };
    } catch (error: any) {
      console.error('Error while fetching the report:', error);
      this.displayMessage = `Failed to fetch config for report. Status: ${error.statusText} Status Code: ${error.status}`;
      console.error(this.displayMessage);
      return;
    }
  }
  


}

interface EmbedConfig {
  type: string;
  id: string;
  embedUrl: string;
  accessToken: string;
  tokenType: string;
}

interface EmbedParams {
  Type: string;
  EmbedReport: {
    ReportId: string;
    ReportName: string;
    EmbedUrl: string;
  }[];
  EmbedToken: {
    Token: string;
    TokenId: string;
    Expiration: string;
  };
}
interface Report {
  ReportId: string;
  ReportName: string;
  EmbedUrl: string;
}
